/**
 * @generated SignedSource<<a3c7a2a75001a3c8d61c4df5e4710b7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RedemptionTypeKey = "CHARITY" | "GIFT_CARD" | "MOBILE" | "PAYPAL" | "VENMO";
export type EGiftCardRewardsQuery$variables = {
  redemptionType: RedemptionTypeKey;
};
export type EGiftCardRewardsQuery$data = {
  readonly redemptionOptions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly amountDenominations: ReadonlyArray<{
          readonly panelistCost: {
            readonly subUnitAmount: number;
          };
        }> | null;
        readonly id: string;
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"useRedemptionOptionItemQuery_optionRef">;
      };
    }>;
  } | null;
};
export type EGiftCardRewardsQuery = {
  response: EGiftCardRewardsQuery$data;
  variables: EGiftCardRewardsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "redemptionType"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "redemptionType",
        "variableName": "redemptionType"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "AmountDenomination",
  "kind": "LinkedField",
  "name": "amountDenominations",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrencyAmount",
      "kind": "LinkedField",
      "name": "panelistCost",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subUnitAmount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EGiftCardRewardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RedemptionOptionConnection",
        "kind": "LinkedField",
        "name": "redemptionOptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RedemptionOptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RedemptionOptionData",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useRedemptionOptionItemQuery_optionRef"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EGiftCardRewardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RedemptionOptionConnection",
        "kind": "LinkedField",
        "name": "redemptionOptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RedemptionOptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RedemptionOptionData",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f38ecf441eed4945436623a7e122e54b",
    "id": null,
    "metadata": {},
    "name": "EGiftCardRewardsQuery",
    "operationKind": "query",
    "text": "query EGiftCardRewardsQuery(\n  $redemptionType: RedemptionTypeKey!\n) {\n  redemptionOptions(input: {redemptionType: $redemptionType}) {\n    edges {\n      node {\n        id\n        name\n        amountDenominations {\n          panelistCost {\n            subUnitAmount\n          }\n        }\n        ...useRedemptionOptionItemQuery_optionRef\n      }\n    }\n  }\n}\n\nfragment useRedemptionOptionItemQuery_optionRef on RedemptionOptionData {\n  imageUrl\n  key\n  name\n}\n"
  }
};
})();

(node as any).hash = "884115fce6088ac5628c121f038ed0f8";

export default node;
